<template>
  <div>
    <transition
      name="modal-fade"
      appear
    >
      <!-- eslint-disable vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
      <div
        v-if="modal"
        class="modal-overlay"
        @click="close"
      />
    </transition>
    <transition
      name="modal-fade"
      appear
    >
      <div
        v-show="modal"
        id="modal-title"
        class="modal"
        role="dialog"
        aria-labelledby="modal-title"
        aria-modal="true"
      >
        <div class="modal-content-wrapper">
          <header class="modal-header">
            <slot name="header" />
            <button
              type="button"
              class="btn-close"
              :class="hideCloseButton && 'hidden'"
              aria-label="Close modal"
              @click="close"
            >
              <CloseRounded class="icon" />
            </button>
          </header>

          <section class="modal-body">
            <slot name="body">
              This is the default body!
            </slot>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  components: {
    CloseRounded: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CloseRounded.vue'),
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    modal(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          document.body.classList.add('is-locked');
        } else {
          document.body.classList.remove('is-locked');
        }
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
      document.body.style.overflow = 'auto';
    },
  },
};
</script>

<style lang="postcss">
.modal-overlay {
  @apply fixed top-0 right-0 left-0 bottom-0 opacity-60 cursor-pointer;
  z-index: 1001; /* To be sure it will be higher than the Leaflet map */
  background-color: #2c3e50;
}

.modal {
  @apply fixed top-1/2 left-1/2 m-auto bg-white p-8;
  width: 90%;
  max-width: 700px;
  max-height: 700px;
  transform: translate(-50%, -50%);
  z-index: 1002;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);

  &-header,
  &-footer {
    @apply flex;
  }

  &-header {
    @apply relative border-b justify-between;
  }

  &-footer {
    @apply flex-col border-b justify-end;
  }

  &-body {
    @apply relative py-5;
  }

  &-title {
    @apply mb-2;
  }

  .btn-close {
    @apply absolute top-1 right-1;
    z-index: 1;

    .icon {
      width: 42px;
      height: 42px;
      top: -20px;
      right: 32px;
    }
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.4s linear;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }
}
</style>
